import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import hotelGroupInfoTemplate from './hotel-group-info-template.pug';
import messageViewTemplate from './message-view-template.pug';
import attentionViewTemplate from './attention-info-template.pug';

const i18n = globalContext.require('component/i18n/loader!campaignui/feature/hotel-center');

/**
 * Class representing a InformationView
 * @extends View
 */
const templateMap = {
  messageView: messageViewTemplate,
  hotelGroupInfo: hotelGroupInfoTemplate,
  attentionView: attentionViewTemplate,
};

export default class InformationView extends DeterministicView {
  initialize({ name = 'messageView' }) {
    this.i18n = i18n;
    this.name = name;
  }

  get template() {
    return templateMap[this.name];
  }

  get events() {
    return this.name === 'attentionView' ? {
      'click .attention-information-dismiss__container input[type=checkbox]': ({ target }) => {
        const isDismiss = target.checked;

        this.setState({ isDismiss });
      },
    } : {};
  }
}
